import axios from 'axios';
import logger from './logger';
export const setupAuthInterceptor = () => {
    // Add a response interceptor
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response) {
                // Handle 401 (Unauthorized) or 403 (Forbidden) errors
                if (error.response.status === 401 || error.response.status === 403) {
                    logger.warn('Authentication error detected, logging out...');
                    // Clear local storage
                    localStorage.clear();
                    // Reload the page to reset the app state
                    window.location.href = '/login';
                }
            }
            return Promise.reject(error);
        }
    );

    // Add a request interceptor to check token expiration
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    // Check if token is expired
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    if (payload.exp * 1000 < Date.now()) {
                        logger.warn('Token expired, logging out...');
                        localStorage.clear();
                        window.location.href = '/login';
                        return Promise.reject('Token expired');
                    }
                } catch (e) {
                    logger.error('Error checking token:', e);
                    localStorage.clear();
                    window.location.href = '/login';
                    return Promise.reject('Invalid token');
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
}; 